import { MutableRefObject, useEffect, useRef, useState } from 'react';

export function useCellWidth(ref: MutableRefObject<HTMLDivElement>) {
  const [cellWidth, setCellWidth] = useState('');
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!ref.current) return () => {};

    const resizeObserver = new ResizeObserver((entries) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const entry of entries) {
        if (timeout.current) clearTimeout(timeout.current);

        timeout.current = setTimeout(() => {
          setCellWidth(`${Math.floor(entry.contentRect.width / 7)}px`);
        }, 100);
      }
    });

    resizeObserver.observe(ref.current);

    return () => resizeObserver.disconnect();
  }, [ref, ref.current]);

  return cellWidth;
}
